"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HelpText;
var _HelpOutline = _interopRequireDefault(require("@mui/icons-material/HelpOutline"));
var _Box = _interopRequireDefault(require("@mui/material/Box/Box.js"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip/Tooltip.js"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography/Typography.js"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function HelpText({
  help,
  ...rest
}) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      gap: 0.25
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
      ...rest
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
      title: help,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_HelpOutline.default, {
        fontSize: "small"
      })
    })]
  });
}